// Корзины длительности для событий GameAnalytics: точные миллисекунды в
// дизайн-событие не положишь (это дерево строк, а не число), а вопрос всегда
// один — «сколько людей ждало недопустимо долго»
const DURATION_BUCKETS_MS = [
  {limit: 1000, name: '0-1s'},
  {limit: 3000, name: '1-3s'},
  {limit: 10000, name: '3-10s'},
];

const SLOWEST_BUCKET_NAME = '10s+';

/**
 * @param {number} durationMs
 * @returns {string} имя корзины: 0-1s | 1-3s | 3-10s | 10s+
 */
export const getDurationBucket = (durationMs) => {
  const bucket = DURATION_BUCKETS_MS.find(({limit}) => durationMs < limit);
  return bucket ? bucket.name : SLOWEST_BUCKET_NAME;
};
